import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  updateRecordStatus({ state, commit }, { orderId, status }) {
    commit('UPDATE_RECORD', { orderId, status })
  },
  refreshLiensAndJudegementReport({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.refreshLiensandjudgement}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchLiensAndJudgementReport({ state }, { liensJudgementjsonData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.liensandjudgment}`,
        liensJudgementjsonData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getLnjOrderSummaryReport({ state }, guid) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.getLnjOrderSummaryReport}/${guid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  GetLnjSupplementOrderDetails({ state }, guid) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.GetLnjSupplementOrderDetails}/${guid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  saveLnJSupplement({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.saveLnJSupplement}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  submitSupplement({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.submitLandJSupplement}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  submitSaveNote({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.saveNote}`,
        payload,
        {
          headers: setHeaders(),
        }
      )

  },
  deleteSavedNote({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.deleteNote}${payload}`,
        {},
        {
          headers: setHeaders(),
        }
      )
  },
  updateNote({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.updateNote}`,
        payload,
        {
          headers: setHeaders(),
        }
      )

  },
}

export const mutations = {
  UPDATE_RECORD(state, record) {
    const a = store.state.reports.reports.find(
      (i) => i.orderId === record.orderId
    )
    a.status = record.status
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
